
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-bridge-hiring-drive/[slug]",
      function () {
        return require("private-next-pages/talent-bridge-hiring-drive/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent-bridge-hiring-drive/[slug]"])
      });
    }
  